export const MODULE_NAME = 'accounts';
export const ACCOUNTS_ROUTE = `/${MODULE_NAME}`;
